import { Component, forwardRef, ChangeDetectorRef, Injector, Input, AfterViewInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BHQrCodeScannerModel } from '../bh-qrcode-scanner.model';
import { PlatformService } from 'src/app/core-api/platform/platform.service';
import { AbstractWorkflowFormComponent } from '../../../@core/abstract-workflow-form-component';
import { WorkflowComponentsService } from '../../../workflow-components.service';
import { BHQrCodeScannerService } from '../bh-qrcode-scanner.service';
import * as moment from 'moment';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
    selector: 'abw-bh-qrcode-scanner-form',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => BHQrCodeScannerFormComponent),
            multi: true
        }
    ],
    templateUrl: './bh-qrcode-scanner-form.component.html',
    styleUrls: ['./bh-qrcode-scanner-form.component.scss']
})
export class BHQrCodeScannerFormComponent extends AbstractWorkflowFormComponent<BHQrCodeScannerModel, any> {
    errString: string;

    constructor(
        private platformService: PlatformService,
        _workflowComponentsService: WorkflowComponentsService,
        _cdf: ChangeDetectorRef,
        _injector: Injector,
    ) {
        super(_workflowComponentsService, _cdf, _injector);
    }

    async scanCode() {
        try {
            const urlScanned = await this.platformService.scanQRCode();
            const regex = /[?&]token=([^&]+)/;
            const match = urlScanned.match(regex);
            if (match.length > 1) {
                this.onValueChanged(match[1]);
                this._cdf.detectChanges();
            }
        } catch (e) {
            console.error(e);
            this.errString = e;
            this._cdf.detectChanges();
        }
    }
}